import * as React from "react";
import ContactFormInfo from "./contact-form-info";
import ContactForm from "./contact-form";
import styled from "styled-components";

/** ContactFormBlock */
interface ContactFormBlockProps {
  /** DANE ZNAJDUJĄCE SIĘ PO LEWEJ STRONIE Z IKONKĄ */
  formInfo?: ContactFormInfoData

  /** DANE DO FORMUALRZA */
  iframeSourceUrl: string
}

const ContactFormBlock = (props: ContactFormBlockProps) => {
  const {formInfo,iframeSourceUrl} = props;
  return (
    <div className="materialize-theme-styles">
      <ContactFormBlockWrapper>
        <ContactFormWrapper>
          <ContactFormInfo {...formInfo}/>
          <ContactForm iframeSourceUrl={iframeSourceUrl} />
        </ContactFormWrapper>
      </ContactFormBlockWrapper>
    </div>
  )
};

const ContactFormBlockWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  @media (min-width : 993px) {
    padding-right: 40px;
    padding-left: 40px;
    margin-top: 100px;
  }
`;

const ContactFormWrapper = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
    @media (max-width : 993px) {
      flex-direction: column;
      padding-right: 40px;
      padding-left: 40px;
    }
  }
`;

export default ContactFormBlock


// WEBPACK FOOTER //
// ./src/layouts/contact-form-block/contact-form-block.tsx